import { NgModule } from '@angular/core';

import { LoadingModule } from '../loading/loading.module';
import { ImageComponent } from './image.component';
import { SharedModule } from '../../shared.module';
import { FilesService } from '../../services/files.service';

@NgModule({
   imports: [
      SharedModule,
      LoadingModule
   ],
   declarations: [
      ImageComponent,
   ],
   exports: [
      ImageComponent
   ],
   providers: [
      FilesService
   ]
})
export class ImageModule { }
